import { Link } from 'react-router-dom';
import { articles, featuredArticles } from '@/mocks/articles';
import { categories } from '@/mocks/categories';

export default function ArticleRecommendSection() {
  const featured = articles.filter((a) => featuredArticles.includes(a.id)).slice(0, 4);
  const latest = [...articles].sort((a, b) => b.publishDate.localeCompare(a.publishDate)).slice(0, 4);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="container-page">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-10 gap-4">
          <div>
            <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold mb-4">
              帮助中心
            </span>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading">
              精选文章
            </h2>
          </div>
          <div className="flex flex-wrap gap-2">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-4 py-1.5 rounded-full text-sm bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                {cat.name}
              </Link>
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {featured.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all duration-300 cursor-pointer"
            >
              <div className="flex flex-col sm:flex-row">
                <div className="sm:w-48 h-40 sm:h-auto flex-shrink-0">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="p-5 flex flex-col justify-center flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="px-2 py-0.5 rounded text-xs bg-accent-100 text-accent-800">
                      {article.categoryName}
                    </span>
                    <span className="text-xs text-foreground-400">{article.publishDate}</span>
                  </div>
                  <h3 className="text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors line-clamp-2 font-heading">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-500 line-clamp-2">{article.excerpt}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10">
          <div className="flex items-center gap-2 mb-5">
            <i className="ri-time-line text-primary-500"></i>
            <h3 className="text-lg font-semibold text-foreground-900 font-heading">最新发布</h3>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {latest.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="group bg-background-50 rounded-lg border border-background-200/70 p-4 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="w-full h-36 rounded-md overflow-hidden mb-3">
                  <img
                    src={article.coverImage}
                    alt={article.title}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <span className="text-xs text-foreground-400">{article.publishDate}</span>
                <h4 className="text-sm font-semibold text-foreground-900 mt-1 group-hover:text-primary-600 transition-colors line-clamp-2 font-heading">
                  {article.title}
                </h4>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}